package ru.astrainteractive.kobwebx.core.resource

sealed class JSResource(val path: String) {
    class Image(path: String) : JSResource(path)
}
